import { graphql } from "gatsby"
import React from "react"
import Content from "../components/organisms/content/content"
import StandardModal from "../shared/components/modals/standard-modal/standard-modal"
import Layout from "../shared/components/organisms/layout/layout"
import SEO from "../shared/seo"
import RegisterService from "../shared/services/register-service"
import "../shared/styles/index.scss"
import { siteUrl } from "../shared/utils/siteUrl"
import RegisterSuccess from "./../shared/components/modals/register-success/register-success"
import StepCodeVerification from "./../shared/components/modals/step-code-verification/step-code-verification"
import StepVerificationMail from "./../shared/components/modals/step-verification-mail/step-verification-mail"
import "./index.scss"

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: false,
      modalActive: null,
    }
  }

  componentDidMount() {
    var url_string = typeof window !== "undefined" ? window.location.href : "/" //window.location.href
    var url = typeof window !== "undefined" ? new URL(url_string) : "/"
    var username =
      typeof window !== "undefined" ? url.searchParams.get("n") : "/"
    var medio =
      typeof window !== "undefined" ? url.searchParams.get("medio") : "/"
    var code = typeof window !== "undefined" ? url.searchParams.get("c") : "/"
    var vconfident = typeof window !== "undefined" ? url.searchParams.get("v") : "/"

    if (username !== null) {
      this.handleVerificationCode(username, code, medio, vconfident)
    }

    if (window.innerWidth < 1024) {
      this.setState({ mobile: true })
    }
    window.addEventListener("resize", this.updateDimensions)
  }

  loginRedirect = () => {
    window.location.href = siteUrl + "/login"
  }

  setModalActive = modal => {
    this.setState({
      modalActive: modal,
    })
  }

  handleVerificationCode = (username, code, medio, vconfident) => {
    if (code !== null) {
      var payload = {
        code,
        username,
      }

      RegisterService.codeVerificationRegister(payload)
        .then(res => {
          if (res.data) {
            if(vconfident === "true") {
              localStorage.setItem("isFromVConfident",true)
            }
            this.setState({
              modalActive: <RegisterSuccess />,
            })
          } else {
            this.setState({
              modalActive: (
                <StandardModal
                  title="Error"
                  subtitle=""
                  description="Tu código ya no es válido o tu cuenta ya fue activada"
                  button_title="Ir al login"
                  click={() => this.loginRedirect()}
                />
              ),
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    } else {
      RegisterService.codeVerificationResend({
        username: username,
      }).then(res => {
        if (medio === "EMAIL") {
          this.setState({
            modalActive: <StepVerificationMail />,
          })
        } else {
          this.setState({
            modalActive: (
              <StepCodeVerification
                setSuccessRegisterModal={this.setModalActive}
              />
            ),
          })
        }
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  setModal = modal => {
    this.setState({ modalActive: modal })
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({ mobile: true })
    } else {
      this.setState({ mobile: false })
    }
  }

  render() {
    return (
      <Layout mobile={this.state.mobile} modalActive={this.state.modalActive} title={this.props.data.allContentfulNolRegistro.nodes[0].metaTitulo}>
        <SEO
          title={this.props.data.allContentfulNolRegistro.nodes[0].metaTitulo}
          description={
            this.props.data.allContentfulNolRegistro.nodes[0].metaDescripcion
              .metaDescripcion
          }
          url={"/registro/"}
        />
        <Content
          femaleCare={this.state.femaleCare}
          contennInfo={this.props.data}
          mobile={this.state.mobile}
          setModal={this.setModal}
        />
      </Layout>
    )
  }
}

export const query = graphql`
  query GET_HOME_CONTENT($locale: String!) {
    allContentfulNolRegistro(filter: { node_locale: { eq: $locale } }) {
      nodes {
        metaTitulo
        metaDescripcion {
          metaDescripcion
        }
      }
    }
  }
`

export default IndexPage
